import { composeWrappers } from "@redotech/react-util/component";
import { initI18n } from "@redotech/redo-i18n/i18n";
import { ErrorPage } from "@redotech/redo-web/error-page";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { ThemeProvider } from "@redotech/redo-web/theme-provider";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { parseBasename } from "./basename";
import { RpcClientProvider } from "./contexts/rpc-client";
import { TanstackQueryClientProvider } from "./providers/tanstack-query";
import "./styles.css";

// English-only: shared components call t(), whose keys are the English copy.
initI18n({ en: {}, loaders: {} });

const basename = parseBasename(location.pathname);

const NotFoundPage = () => {
  return (
    <Flex align="center" dir="column" justify="center" p="3xl">
      <Text fontSize="lg" fontWeight="semibold">
        Page not found
      </Text>
    </Flex>
  );
};

// Bearer-token-in-URL auth: no AuthGuard — the session token IS the capability.
const router = createBrowserRouter(
  [
    {
      path: "/hsa",
      errorElement: <ErrorPage />,
      children: [
        {
          path: ":sessionToken",
          lazy: async () => {
            const { HsaPortalPage } = await import("./hsa/page");
            return { Component: HsaPortalPage };
          },
        },
      ],
    },
    {
      path: "/hsa-survey",
      errorElement: <ErrorPage />,
      children: [
        {
          path: ":sessionToken",
          lazy: async () => {
            const { HsaHandoffPage } = await import("./hsa-survey/page");
            return { Component: HsaHandoffPage };
          },
        },
      ],
    },
    { path: "*", element: <NotFoundPage />, errorElement: <ErrorPage /> },
  ],
  { basename },
);

const CheckoutApp = () => {
  return composeWrappers(
    (inner) => (
      <TanstackQueryClientProvider>{inner}</TanstackQueryClientProvider>
    ),
    (inner) => <ThemeProvider>{inner}</ThemeProvider>,
    (inner) => <RpcClientProvider>{inner}</RpcClientProvider>,
  )(<RouterProvider router={router} />);
};

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
createRoot(rootElement).render(<CheckoutApp />);
